import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, NgForm} from "@angular/forms";
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {TerminalsBankJob} from "../../../../shared/interface/terminals-Bank-job";
import {interval, ReplaySubject} from "rxjs";
import {UserPermissions} from "../../../../shared/interface/user-permissions";
import {MatDialog} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {AuthService} from "../../../../shared/services/auth.service";
import {FilterService} from "../../../../shared/services/filter.service";
import {ActivatedRoute, Router} from "@angular/router";
import {select, Store} from "@ngrx/store";
import {StoreRootState} from "../../../../shared/ngrx/reducers";
import {delay, distinctUntilChanged, takeUntil, tap} from "rxjs/operators";
import {CountedAndPaginated} from "../../../../shared/interface/response/counted-and-paginated";
import {getCurrentRouteState} from "../../../../shared/ngrx/selector";
import {RouterStateUrl} from "../../../../shared/ngrx/route-serializer";
import {ReceivablesBankJob} from "../../../../shared/interface/receivables-bank-job";
import {ReceivablesBankJobService} from "../../../../shared/services/receivables-bank-job.service";
import {ConfirmDialogComponent} from "../../../../shared/components/confirm-dialog/confirm-dialog.component";
import {Uuid} from "../../../../shared/interface/response/uuid";
import {JobResultDialogComponent} from "../../../../shared/components/job-result-dialog/job-result-dialog.component";
import {HttpErrorResponse} from "@angular/common/http";

@Component({
  selector: 'app-transfer-bank-job-list',
  templateUrl: './transfer-bank-job-list.component.html',
  styleUrls: ['./transfer-bank-job-list.component.scss']
})
export class TransferBankJobListComponent implements AfterViewInit, OnInit, OnDestroy  {
  @ViewChild('filtersForm') filtersForm: NgForm;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  initialFilters: any;
  jobs: ReceivablesBankJob[] = [];
  displayedColumns: string[] = [ 'createdAt', 'createdBy', 'totalRows', 'sum', 'status', 'actions'];
  totalData = 0;
  userPermissions: ReplaySubject<UserPermissions>;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private dialog: MatDialog,
    private snack: MatSnackBar,
    private auth: AuthService,
    private filterService: FilterService,
    private activatedRoute: ActivatedRoute,
    private store: Store<StoreRootState>,
    private router: Router,
    private receivablesBankJobService: ReceivablesBankJobService,
  ) {
    this.userPermissions = auth.getUserPermissions();
    this.receivablesBankJobService.jobListSubject
      .pipe(
        takeUntil(this.destroyed$),
        tap((e: CountedAndPaginated<ReceivablesBankJob>) => {
          this.jobs = e.items;
          this.totalData = e.pagination.total;
        })
      ).subscribe();
    this.parseFilters();
  }

  parseFilters(filters?: any): void {
    this.initialFilters = this.filterService.parseFiltersFromQueryParams({
    }, filters);
  }

  ngOnInit(): void {
    interval(1000)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(() => {
        if (this.paginator.pageIndex === 0) {
          this.loadListData();
        }
      });
  }

  ngAfterViewInit(): void {
    this.paginator.page
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe((event: PageEvent) => {
      this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
        page: event.pageIndex,
        pageSize: event.pageSize,
        ...this.filtersForm.value
      })]);
    });

    this.store
      .pipe(
        select(getCurrentRouteState),
        delay(0),
        distinctUntilChanged((prev: RouterStateUrl, curr: RouterStateUrl) => prev.url === curr.url),
        takeUntil(this.destroyed$),
      )
      .subscribe((state: RouterStateUrl) => {
        this.parseFilters(state.params);
        this.paginator.pageIndex = state.params.page;
        this.paginator.pageSize = state.params.pageSize;

        this.loadListData();
      })
    ;
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  buildFilters(): any {
    const filters = {...this.initialFilters};

    return filters;
  }

  loadListData(): void {
    this.receivablesBankJobService.loadList(this.paginator.pageIndex, this.paginator.pageSize, this.buildFilters());
  }

  filter(): void {
    this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
      page: 0,
      pageSize: this.paginator.pageSize,
      ...this.filtersForm.value,
    })]);
  }


  resetFilters(): void {
    this.filtersForm.resetForm();
    this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, {
      page: 0,
      pageSize: this.paginator.pageSize,
    }]);
  }

  trackTask(index: number, receivablesBankJob: ReceivablesBankJob): string {
    return receivablesBankJob.uuid;
  }

  downloadBankFile(receivablesBankJob: ReceivablesBankJob): void {
    this.receivablesBankJobService.downloadBankFile(receivablesBankJob.uuid);
  }

  deleteFile(terminalsBankJob: TerminalsBankJob): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz usunąć plik?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.receivablesBankJobService.deleteBankFIle(terminalsBankJob.uuid)
          .subscribe((response: Uuid) => {
            const dialogRefv1 = this.dialog.open(JobResultDialogComponent, {
              disableClose: true,
              width: '500px',
              data: {jobId: response.uuid, showProgress: false},
            });

            dialogRefv1.afterClosed().subscribe(() => {
              this.snack.open('Pomyślnie usunięto plik', '', {duration: 2000});
            });
          }, (error: HttpErrorResponse) => {
            this.snack.open('Przy usuwaniu pliku wystąpił błąd', error.status.toString(), {duration: 4000});
            if (error.status === 400) {
              this.snack.open(error.error.error.text, '400', {duration: 4000});
            }
          });
      }
    });
  }
}
